import {System} from '../../shared-components/System';

export class AssignmentFilterParam {

	// Properties
    private _FromDueDate?: Date;
    private _ToDueDate?: Date;
    private _FromAssignedDate?: Date;
    private _ToAssignedDate?: Date;
    FromPercentage?: number;
    ToPercentage?: number;
    Course?: string;
    Term?: string;
    Category?: string;
    Grade?: string;

    // Class Functions
    constructor() {
    }

    isFilterApplied(): boolean {
        return (!!this.FromDueDate || !!this.ToDueDate || !!this.FromAssignedDate || !!this.ToAssignedDate || !!this.FromPercentage || !!this.ToPercentage || !!this.Category || !!this.Grade);
    }

    get FromDueDate(): Date {
    	return this._FromDueDate;
	}

	set FromDueDate(value: Date) {
    	System.roundDateDown(value);
    	this._FromDueDate = value;
	}

	get ToDueDate(): Date {
    	return this._ToDueDate;
	}

	set ToDueDate(value: Date) {
    	System.roundDateUp(value);
    	this._ToDueDate = value;
	}

	get FromAssignedDate(): Date {
    	return this._FromAssignedDate;
	}

	set FromAssignedDate(value: Date) {
    	System.roundDateDown(value);
    	this._FromAssignedDate = value;
	}

	get ToAssignedDate(): Date {
    	return this._ToAssignedDate;
	}

	set ToAssignedDate(value: Date) {
    	System.roundDateUp(value);
    	this._ToAssignedDate = value;
	}
}